import { AfterViewInit, Directive, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

/**
 * This directive disables or enables a ngForm control dynamically based on an input
 *
 * How to:
 *
 * @example
 * <input type="number" formControlName="example" [cwDisableControl]="hasToDisableControl()">
 */
@Directive({
    selector: '[cwDisableControl]',
    standalone: false,
})
export class DisableControlDirective implements AfterViewInit {
    /** Enables or disables the form control depending the condition */
    @Input() set cwDisableControl(condition: boolean) {
        this._cwDisableControl = condition;
        this.updateEnabledState(condition);
    }

    get cwDisableControl(): boolean {
        return this._cwDisableControl;
    }

    private _cwDisableControl = false;

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.updateEnabledState(this.cwDisableControl);
        });
    }

    constructor(private ngControl: NgControl) {}

    private updateEnabledState(state: boolean): void {
        const action = state ? 'disable' : 'enable';
        this.ngControl.control?.[action]();
    }
}
